import { render, staticRenderFns } from "./yk.vue?vue&type=template&id=2f9f3252"
import script from "./yk.vue?vue&type=script&lang=js"
export * from "./yk.vue?vue&type=script&lang=js"
import style0 from "./yk.vue?vue&type=style&index=0&id=2f9f3252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports